import toastr from 'react-hot-toast';
import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { CACHE_AND_STALE_TIME } from 'constants/index';
import {
  generateAppendQueryParam,
  generateFilter,
  generatePaginationQuery,
  generateSortQuery,
  generateURL,
} from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import type { TranscriptionsResponse } from 'types/Transcriptions';

const getTranscription = (fileID: string | undefined | null) => {
  if (!fileID) {
    return Promise.reject('File ID is required');
  }

  const queryArray = [
    generateFilter('fileID', fileID, 'equal'),
    generatePaginationQuery({ pageNumber: 1, pageSize: 1 }),
    generateSortQuery('createdAt', 'Decs'),
    generateAppendQueryParam('includeData', true),
  ];

  const url = generateURL(SPARK_RESOURCE_TYPES.TRANSCRIPTIONS, queryArray);

  return fetchWrapper<TranscriptionsResponse>({
    url,
    method: 'GET',
  });
};

export function useTranscriptionByFileID(fileID: string | undefined | null) {
  const response = useQuery(
    [SPARK_RESOURCE_TYPES.TRANSCRIPTIONS, fileID],
    () => getTranscription(fileID),
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(`Failed to fetch transcription: ${error.message}`);
        }
      },
      enabled: !!fileID,
      ...CACHE_AND_STALE_TIME,
    }
  );

  const { data: transcriptionResponse } = response || {};
  const { data: transcription } = transcriptionResponse || {};

  return {
    transcription: transcription?.[0], // there should be only one record
    ...response,
  };
}
